import { stringify } from 'qs';
import request from '@/utils/request';

export async function getTenancyUsers(params) {
  return request(`/mvnos/users?${stringify(params)}`);
}

export async function getTenancyChild() {
  return request('/mvnos/allChild');
}

export async function lockUser(userId) {
  return request(`/users/${userId}/lock`, {
    method: 'PATCH',
  });
}

export async function unLockUser(userId) {
  return request(`/users/${userId}/unLock`, {
    method: 'PATCH',
  });
}

export async function disableUser(userId) {
  return request(`/users/${userId}/disable`, {
    method: 'PATCH',
  });
}

export async function enableUser(userId) {
  return request(`/users/${userId}/enable`, {
    method: 'PATCH',
  });
}

export async function addTenancyUser(params) {
  return request(
    '/mvnopaas',
    {
      method: 'POST',
      body: {
        ...params,
      },
    },
  );
}

export async function updateTenancyUser(params) {
  return request('/mvnopaas', {
    method: 'PUT',
    body: {
      ...params,
    },
  });
}

export async function deleteTenancy({ spId }) {
  return request(`/mvnos/${spId}`, {
    method: 'DELETE',
  });
}

export async function updateTenancy(params) {
  return request('/mvnos', {
    method: 'PUT',
    body: {
      ...params,
    },
  });
}

export async function getRoles() {
  return request('/mvnos/self/roles');
}

export async function getRolesByUserId(id) {
  return request(`/users/${id}/roles`);
}

export async function changeUserRoles(userId, params, method = 'POST') {
  return request(`/users/${userId}/roles`, {
    method,
    body: params,
  });
}

export async function resetPwd(userId) {
  return request(`/users/${userId}/pwd`, {
    method: 'PATCH',
  });
}

export async function getUserSps() {
  return request('/mvnos/currentUser/sps');
}

export async function getCurrentUserSp() {
  return request('/mvnos/currentUser/sp');
}
